import type { FollowUpMoment } from '@common/customControls/bariatrics';
import { followUpMoments } from '@common/customControls/bariatrics';

export function determineFollowUpMoments({
    currentFollowUpMoment,
    lastFollowUpMoment,
    wasPresentAtLastFollowUp,
}: {
    currentFollowUpMoment?: FollowUpMoment;
    lastFollowUpMoment?: FollowUpMoment;
    wasPresentAtLastFollowUp: boolean;
}): FollowUpMoment[] {
    const lastFollowUpIndex = followUpMoments.findIndex((followUpMoment) => followUpMoment === lastFollowUpMoment);

    // If patient was present, take index one higher for the next follow-up moment. If it was -1, set it to 0.
    const nextFollowUpIndex =
        (lastFollowUpIndex > -1 && wasPresentAtLastFollowUp) || lastFollowUpIndex === -1
            ? lastFollowUpIndex + 1
            : lastFollowUpIndex;

    let startMoment = nextFollowUpIndex;

    if (currentFollowUpMoment) {
        const currentFollowUpIndex = followUpMoments.findIndex(
            (followUpMoment) => followUpMoment === currentFollowUpMoment
        );
        if (currentFollowUpIndex < nextFollowUpIndex) {
            startMoment = currentFollowUpIndex;
        } else if (currentFollowUpIndex > nextFollowUpIndex) {
            startMoment = currentFollowUpIndex - 1;
        }
    }

    // Always return the (max.) two next follow-up moments
    return followUpMoments.slice(startMoment, startMoment + 2);
}
